import React from 'react'
import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

interface StreamingIndicatorProps {
  state: 'idle' | 'connecting' | 'streaming' | 'error'
}

const StreamingIndicator: React.FC<StreamingIndicatorProps> = ({ state }) => {
  const { t } = useTranslation()

  if (state === 'idle') return null

  const config = {
    connecting: {
      color: '#FFC107',
      label: t('tts.connecting', 'Connecting...'),
      animate: true,
    },
    streaming: {
      color: '#4CAF50',
      label: t('tts.streaming', 'Streaming...'),
      animate: true,
    },
    error: {
      color: '#F44336',
      label: t('tts.streamError', 'Error'),
      animate: false,
    },
  }[state]

  return (
    <Box
      role="status"
      aria-live="polite"
      sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
    >
      <Box
        sx={{
          width: 10,
          height: 10,
          borderRadius: '50%',
          backgroundColor: config.color,
          flexShrink: 0,
          ...(config.animate && {
            animation: 'tts-pulse 1.4s ease-in-out infinite',
            '@keyframes tts-pulse': {
              '0%': { opacity: 1, transform: 'scale(1)' },
              '50%': { opacity: 0.4, transform: 'scale(0.8)' },
              '100%': { opacity: 1, transform: 'scale(1)' },
            },
          }),
        }}
      />
      <Typography variant="caption" sx={{ color: config.color, fontWeight: 600 }}>
        {config.label}
      </Typography>
    </Box>
  )
}

export default StreamingIndicator
